$ = require 'jquery'
Auth = require 'db/auth'
ChangeSetPasswordPopoverView = require 'views/member/change-set-password-popover-view'
ChangeLocaleView = require 'views/member/change-locale-view'
Controller = require 'controller'
HelpComponent = require 'views/header/help-component'
l = require 'lib/localize'
PopOver = require 'views/lib/pop-over'
React = require 'react'
Util = require 'lib/util'
View = require 'view'
log = require 'debug/log'
f = require 'effing'
template = require 'views/templates/header_member_menu'
{ locales } = require 'db/locale-information'
ClientConfig = require 'debug/client-config'
Storage = require 'lib/storage'

track = f(require('debug/track'), "Header", "User Menu")
tracker = (area) -> -> track area

module.exports = class HeaderMemberMenuView extends View
  initialize: ->
    @listenTo @model, 'change:loginTypes', @frameDebounce @render

  getViewTitle: -> @model.getMemberViewTitle()

  events:
    'click .js-profile': tracker "Profile"
    'click .js-cards': tracker "Cards"
    'click .js-billing': tracker "Billing"
    'click .js-account': tracker "Settings"

    'click .js-help': (e) ->
      tracker "Help"
      if Auth.isLoggedIn()
        Util.stop(e)
        PopOver.show
          getViewTitle: ->
            l(['view title', 'help'])
          maxWidth: 500
          clientx: $(window).width() - 500
          clienty: 40
          elem: e.currentTarget
          reactElement: React.createElement HelpComponent, { key: 'help' }

    'click .js-shortcuts': tracker "Shortcuts"
    'click .js-change-locale': 'changeLocale'

    'click .js-logout': 'logout'

  render: ->
    log('render', "rendering HeaderMemberMenuView")

    data =
      onAnyBoardView: Controller.onAnyBoardView()
      profileUrl: Controller.getMemberProfileUrl()
      cardsUrl: Controller.getMemberCardsUrl()
      billingUrl: Controller.getMemberBillingUrl()
      accountUrl: Controller.getMemberAccountUrl()
      canLogOut: Auth.canLogIn()
      hasAccount: @model.hasMemberOrOrgAccount()
      upsellEnabled: !ClientConfig.get('dontUpsell')

    @$el.html template(data)

    @

  changeLocale: (e) ->
    track "Change Locale"
    Util.stop(e)
    PopOver.pushView
      view: new ChangeLocaleView
        model: @model
        modelCache: @modelCache
        onChange: (newLocale, oldLocale) ->
          if oldLocale == newLocale
            PopOver.popView()
          else
            Storage.unset 'tacoShow'
            document.location.reload()
    return

  logout: (e) ->
    if Auth.canLogIn()
      Auth.logoutPost()
      track "Log Out"
    else
      # We can't let them log out; they haven't set a password!
      PopOver.pushView
        view: new ChangeSetPasswordPopoverView({ @model, @modelCache })
      Util.stop(e)



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-member-menu-view.coffee